module.exports = __webpack_public_path__ + "media/logos/carq_and_yanosik-22678c39.svg";